// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-k_hc","advertDetailContactItem__link":"c-k_he","advertDetailContactItem__stub":"c-k_hf"};